import { dataDomains, type DataDomain } from '@/queries/dataDomains'
import { queryClient } from '@/queries/queryClient'
import { ref } from 'vue'

export const appLoadError = ref<Error | null>(null)

let lastRequired: readonly DataDomain[] = []

export const ensureRouteData = async (required: readonly DataDomain[]): Promise<void> => {
  lastRequired = required
  try {
    await Promise.all(
      required.map((domain) =>
        queryClient.ensureQueryData(dataDomains[domain]() as ReturnType<(typeof dataDomains)['dogs']>),
      ),
    )
    appLoadError.value = null
  } catch (error) {
    appLoadError.value = error instanceof Error ? error : new Error('Something went wrong')
  }
}

export const retryRouteLoad = (): Promise<void> => ensureRouteData(lastRequired)
